import React, { forwardRef, useContext, useId, useState } from "react";
import styled from 'styled-components';
import classNames from "classnames";
import GradeFooter from "./GradeFooter";
import IBuildrProps from '../../utilities/IBuildrProps';
import { IChecklistState } from "./Checklist";
import ChecklistItemModal from "./ChecklistItemModal";
import ModalContext from "../../context/ModalContext";

interface IExperienceProps extends IBuildrProps {
    tabId: number,
    selected: boolean;
    dispatch: any;
    state: IChecklistState;
    experienceTitle: string;
    experienceSubTitle: string;
    children: any;
    width: string;
}

export default styled(forwardRef(({
    tabId,
    cmsId,
    editorClassObj,
    selected,
    dispatch,
    state,
    experienceTitle,
    experienceSubTitle,
    children,
    width,
    className
}: IExperienceProps, ref: any) => {

    const modalContext = useContext(ModalContext);
    const [modalStatus, setModalStatus] = useState({modalTitle: '', modalText: '', modalImage: ''});
    const uniqueModalId = useId();
    const openModal = (modalTitle, modalText, modalImage) => {
        setModalStatus({ modalTitle, modalText, modalImage });
        modalContext.openModal(uniqueModalId);
    };
    
    const { modalImage, modalTitle, modalText } = modalStatus;

    function openTab() {
        dispatch({
            type: 'general_update',
            payload: {
                activeTab: tabId,
            },
        })
    }

    return (
        <>
            <div data-id={cmsId} ref={ref} style={{ width }} className={classNames("experience-tab p-3", className, editorClassObj, { selected })} onClick={openTab}>
                <div className="inner-tab px-3 py-4">
                    <h2 className="text-serif m-0">{experienceTitle}</h2>
                    <p className="m-0">{experienceSubTitle}</p>
                </div>
            </div>
            <div data-id={cmsId} className={classNames("experience-tab-content px-3 w-100 pb-1", className, editorClassObj, { selected })} ref={ref}>
                <hr className="mt-2 mb-0 py-3" />
                <p className="pt-2 mb-2">Use this checklist to determine whether a car is a good buy.</p>
                {React.Children.map(children, (child, index) => {
                    const isCheckListItem = child.props.hasOwnProperty('severity');
                    return (
                        <>
                            {React.cloneElement(child, {
                                selections: isCheckListItem ? state.selections : null,
                                dispatch: isCheckListItem ? dispatch : null,
                                tabId: isCheckListItem ? tabId: null,
                                index: isCheckListItem ? index: null,
                                className: isCheckListItem ? null : 'non-checklist-item', /* classname for zebra striping */
                                openModal,
                            })}
                            {isCheckListItem ? null: <div />} {/* add extra div for zebra striping */}
                        </>
                    );
                })}
            </div>
            <ChecklistItemModal modalId={uniqueModalId} modalImage={modalImage} modalTitle={modalTitle} modalText={modalText} />
            {selected && <GradeFooter tabId={state.activeTab} selections={state.selections || []} totalItems={children?.filter(c => c.props.hasOwnProperty('severity'))?.length || 0} />}
        </>
    );
}))`
&.experience-tab {
    order: 1;

    &.selected {
        .inner-tab {
            background-color: #F0AB00;
            border: 2px solid #808080;
        }
    }
}

.inner-tab {
    height: 100%;
    width: 100%;
    color: white;
    background-color: #e4e5e6;
    padding: 30px 100px;
    border-radius: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 600px) {
        h2 {
            font-size: 2rem;
        }
        p {
            font-size: .8rem;
        }
    }
}

&.experience-tab-content {
    order: 2;
    > div:nth-of-type(even):not(.non-checklist-item) {
        background-color: #EFF0F0;
    }
}

&.experience-tab-content:not(.selected) {
    display: none;
}

hr {
    border: 0;
    border-top: 1px solid #eee;
}
`;